<template>
  <div
    class="DocumentBlock DocumentHeading -heading group bg-white"
    :class="{ isCommentOpened: isCommentOpened, DocumentHighlightSearch: $route.hash === '#el' + element.id }"
    :id="'el' + element.id"
    v-bc-get-box-model="{name: element.id ? 'elementHeading' + element.id : null}"
  >
    <div class="DocumentElement -heading">
      <div
        class="w-full bg-bc-blue flex flex-row justify-center space-x-2 p-4"
        v-if="element.locked && !isEveryElementLocked && !isPageLocked"
      >
        <aw-icon icon="lock" class="w-5 h-5 text-white " />
        <span class="text-white text-sm">{{ $t('Element is locked') }}</span>
      </div>

      <contenteditable
        tag="span"
        v-model="data.header"
        :contenteditable="edit"
        :noNL="true"
        :noHTML="true"
        :alwaysSelectAll="bcDocumentStore.isNewDocument ? true : $t('Title')"
        @updated="updated = 'header'"
        :auto-focus="!element.id || bcDocumentStore.isNewDocument"
      />

      <!-- comments -->
      <document-comment
        v-if="bcDocumentStore.document.allow_comments"
        v-model="element.comments"
        :element="element"
        :document="bcDocumentStore.document"
        @comment-toggle="resolveZindexOnParent"
      />

      <!-- Tooltip panel on hover -->
      <!-- <hr />
      <dummy-tooltip-marker number="1">tooltip</dummy-tooltip-marker>
      <document-tooltip-bubble /> -->

      <!-- panel s moznosti noveho elementu -->
      <document-hot-action
        :parent="parent"
        :page="page"
        :index="0"
        v-if="edit && page.children.length > 0"
      />
    </div>

    <!-- LEVA -->
    <div class="DocumentBlock__PanelLeft -heading">
      <aw-icon
        icon="cart"
        class="w-8 h-8 text-gray-400 hover:text-bc-blue cursor-pointer"
        v-if="showEshopIcon"
        @click.prevent.stop="editProducts"
        v-aw-driver-element="'DocumentEnableEshop'"
      ></aw-icon>
      <a
        v-if="!edit && page.data.products && page.data.products.length"
        :href="'#eshop' + page.id"
        class="text-gray-400 hover:text-bc-blue"
      >
        <aw-icon
          icon="cart"
          class="w-8 h-8"
        ></aw-icon>
      </a>
    </div>
    <!-- PRAVA -->

    <div class="DocumentBlock__PanelRight -heading">
      <span
        ref="DocumentCircle"
        class="DocumentCircle mr-2.5 sm:mr-3.5"
        :class="{
          'DocumentCircle--active':
            bcSelectedStore.selected.has(element.id) &&
            bcSelectedStore.selected.get(element.id)[3],
          'DocumentCircle--child-active':
            bcSelectedStore.selected.has(element.id) &&
            !bcSelectedStore.selected.get(element.id)[3]
        }"
        :data-item-index="element.root_rank"
        @click.prevent.stop="bcSelectedStore.select(
          element, 
          {
            isRecursive: true,
            isShift: $event.shiftKey,
            isDocument: true,
            itemIndex: element.root_rank,
          }
        )"
      ></span>
      <span
        class="cursor-move text-gray-400 hover:text-gray-500"
        v-if="edit"
        :ref="dragHandle"
      >
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
      </span>
    </div>
  </div>
</template>

<script>
import BaseElement from '../../mixins/BaseElement'
import Selected from '../../mixins/Selected'
import elementsBoxModel from '../../elementsBoxModel'
import { mapStores } from 'pinia'
import useDndStore from '@/frontapp/store/dnd'

export default {
  mixins: [
    BaseElement, 
    Selected,
  ],
  emits: ['editProducts'],
  disableUpdate: true, // disable default update watch, on heading this has to be done by page element
  props: {
    dragHandle: {
      type: Function,
      required: true
    },
    dragEl: {
      type: Function,
      default: null
    },
    pageIndex: {
      type: Number,
      default: null
    }
  },
  computed: {
    showEshopIcon() {
      return this.edit && this.$presenter.hasEshop === 1
    },
    ...mapStores(useDndStore),
  },
  methods: {
    editProducts() {
      this.$emit('editProducts')
    },
    getDragEl() {
      if (this.dndStore.currentPageIndex === this.pageIndex && this.$el.offsetTop > elementsBoxModel['elementHeading' + this.element.id].parent.paddingTop) {        
        this.dragEl(this.$el)
      }
    }
  },
  mounted() {
    this.dndStore.clbs.add(this.getDragEl)
    this.assignItemToSelectBtn('DocumentCircle', this.element)
  },
  unmounted() {
    this.dndStore.clbs.delete(this.getDragEl)
  },
}
</script>

<style lang="scss" scoped></style>
